function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import { getArcProperties } from "./utils";
import renderFilter from "./_filter";
import RadialProgress from "./RadialProgress";
import "./ProgressInfinite.css";
export default class ProgressInfinite extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "componentDidMount", renderFilter);
  }
  render() {
    const {
      color,
      className,
      ...rest
    } = this.props;
    const classes = classnames(className, "ax-progress-infinite", `ax-progress-infinite--${color}`);
    const {
      diameter,
      innerRadius,
      strokeWidth,
      strokeDasharray,
      strokeDashoffset
    } = getArcProperties({
      percent: 75
    });
    return /*#__PURE__*/React.createElement(RadialProgress, _extends({}, rest, {
      className: classes,
      diameter: diameter
    }), /*#__PURE__*/React.createElement("circle", {
      className: "ax-progress-infinite__arc",
      r: innerRadius,
      style: {
        stroke: `url(#ax-progress-infinite__filter--${color})`,
        strokeDasharray,
        strokeDashoffset,
        strokeWidth
      }
    }));
  }
}
_defineProperty(ProgressInfinite, "defaultProps", {
  color: "subtle",
  size: "small"
});